import React, { useState } from 'react';
import { Gift, ArrowRight, Loader2, Check } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const PromoCodeModal = ({ onClose, onNeedRegister }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [validCode, setValidCode] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    
    setLoading(true);
    setError('');
    
    try {
      // First, check if code exists (we'll validate it without auth)
      // For now, we just pass the code to register flow
      const codeUpper = code.toUpperCase().trim();
      
      // Store the code and redirect to register
      localStorage.setItem('pendingPromoCode', codeUpper);
      setValidCode(codeUpper);
      
      // After 1.5 seconds, redirect to register
      setTimeout(() => {
        onNeedRegister(codeUpper);
      }, 1500);
      
    } catch (err) {
      setError(err.response?.data?.detail || 'Código no válido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div className="w-full max-w-md bg-[#0d0d0f] border border-gray-800 rounded-2xl p-6 sm:p-8 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors"
        >
          ✕
        </button>

        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-purple-500/20 to-pink-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Gift className="w-8 h-8 text-purple-400" />
          </div>
          <h2 className="text-2xl font-bold text-white">Código Promocional</h2>
          <p className="text-gray-400 text-sm mt-2">
            Introduce tu código para obtener acceso premium gratuito
          </p>
        </div>

        {/* Success State */}
        {validCode && (
          <div className="text-center">
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Check className="w-8 h-8 text-green-400" />
            </div>
            <p className="text-green-400 font-medium mb-2">¡Código guardado!</p>
            <p className="text-gray-400 text-sm">
              Ahora regístrate para activar tu acceso premium con el código <span className="text-purple-400 font-mono">{validCode}</span>
            </p>
          </div>
        )}

        {/* Form */}
        {!validCode && (
          <>
            {error && (
              <div className="mb-4 p-3 bg-red-500/10 text-red-400 border border-red-500/20 rounded-lg text-sm">
                {error}
              </div>
            )}
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm text-gray-400 mb-2">Tu código</label>
                <input
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value.toUpperCase())}
                  className="w-full px-4 py-4 bg-[#0a0a0b] border border-gray-700 rounded-lg focus:outline-none focus:border-purple-500 transition-colors text-center text-xl tracking-widest font-mono uppercase"
                  placeholder="CODIGO123"
                  autoFocus
                  data-testid="landing-promo-input"
                />
              </div>
              
              <button
                type="submit"
                disabled={loading || !code.trim()}
                className="w-full py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg font-semibold hover:from-purple-400 hover:to-pink-400 transition-all flex items-center justify-center gap-2 disabled:opacity-50"
                data-testid="landing-promo-submit"
              >
                {loading ? (
                  <Loader2 className="w-5 h-5 animate-spin" />
                ) : (
                  <>
                    Continuar
                    <ArrowRight className="w-5 h-5" />
                  </>
                )}
              </button>
            </form>
            
            <p className="text-center text-gray-500 text-sm mt-6">
              Los códigos son proporcionados por TraceMetrics para acceso especial
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default PromoCodeModal;
